import { GET } from '../../common/common.service'
import endpointsPurchasesSummary from './endpoints'

export const PurchasesSummaryService = {
  getAll: async ({
    filter,
    sort,
    limit,
    skip,
    dateFrom,
    dateTo,
    ownStation,
    supplier,
    isTotal,
  }) =>
    GET(
      endpointsPurchasesSummary.LOAD(
        filter,
        sort,
        limit,
        skip,
        dateFrom,
        dateTo,
        ownStation,
        supplier,
        isTotal,
      ),
    ),
}
